/* =========================================================
   FFF – scripts des sections « fff-… »
   Panier (ajout rapide, compteur), menu mobile, filtres du catalogue,
   fiche produit (galerie, variantes, stock, barre collante).
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Outils ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var fmt = format || window.FFF_MONEY_FORMAT || '{{amount_with_comma_separator}} €';
    function withDelimiters(number, precision, thousands, decimal) {
      thousands = typeof thousands === 'undefined' ? ',' : thousands;
      decimal = typeof decimal === 'undefined' ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }
    var match = fmt.match(placeholder);
    if (!match) return String(cents / 100);
    switch (match[1]) {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      default: value = withDelimiters(cents, 2);
    }
    return fmt.replace(placeholder, value);
  }

  /* ---------- Panier ---------- */
  function setCartCount(n) {
    $$('[data-fff-cart-count]').forEach(function (el) {
      if (el.textContent !== String(n)) el.textContent = n;
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); return cart; });
  }

  function openCart() {
    if (window.cartType === 'drawer' && typeof window.__openCartDrawer === 'function') {
      window.__openCartDrawer();
    } else {
      window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart';
    }
  }

  function addToCart(body) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: body
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg = (data && (data.description || data.message)) || "Impossible d'ajouter cet article.";
          throw new Error(msg);
        }
        return data;
      });
    }).then(function () {
      return refreshCartCount();
    });
  }

  // Garde le compteur mobile à jour quand le tiroir modifie #CartCount
  function watchCartCount() {
    var main = document.getElementById('CartCount');
    if (!main || !window.MutationObserver) return;
    new MutationObserver(function () { setCartCount(main.textContent.trim()); })
      .observe(main, { childList: true, characterData: true, subtree: true });
  }

  // Ajout rapide depuis les cartes produit
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-fff-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var fd = new FormData();
    fd.append('id', btn.getAttribute('data-fff-add'));
    fd.append('quantity', '1');
    btn.classList.add('is-loading');
    addToCart(fd).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-done');
      setTimeout(function () { btn.classList.remove('is-done'); }, 1600);
      openCart();
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      window.alert(err.message);
    });
  });

  // Carte produit : survol d'une pastille de coloris = photo de ce coloris
  function swatchPreview(e) {
    var sw = e.target.closest && e.target.closest('[data-fff-swatch-img]');
    if (!sw) return;
    var card = sw.closest('[data-fff-card]');
    var pic = card && card.querySelector('.fff-card__pic');
    if (!pic) return;
    if (!pic.dataset.fffOrig) { pic.dataset.fffOrig = pic.currentSrc || pic.src; }
    if (!pic.dataset.fffOrigSet) { pic.dataset.fffOrigSet = pic.getAttribute('srcset') || ''; }
    pic.removeAttribute('srcset');
    pic.src = sw.getAttribute('data-fff-swatch-img');
    card.classList.add('is-swatching');
    card.querySelectorAll('.fff-swatch').forEach(function (x) { x.classList.toggle('is-on', x === sw); });
  }
  document.addEventListener('mouseover', swatchPreview);
  // En quittant la carte, on remet la photo d'origine
  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('[data-fff-card].is-swatching');
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    var pic = card.querySelector('.fff-card__pic');
    if (pic && pic.dataset.fffOrig) {
      if (pic.dataset.fffOrigSet) pic.setAttribute('srcset', pic.dataset.fffOrigSet);
      pic.src = pic.dataset.fffOrig;
    }
    card.classList.remove('is-swatching');
    card.querySelectorAll('.fff-swatch').forEach(function (x) { x.classList.remove('is-on'); });
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-fff-swatch-img]')) { e.preventDefault(); swatchPreview(e); }
  });

  /* ---------- Menu mobile ---------- */
  function initMenu(root) {
    var menu = $('[data-fff-menu]', root);
    var openBtn = $('[data-fff-menu-open]', root);
    if (!menu || !openBtn || openBtn.dataset.fffBound) return;
    openBtn.dataset.fffBound = '1';
    var lastFocus = null;

    function open() {
      lastFocus = document.activeElement;
      menu.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var first = $('[data-fff-menu-close]', menu);
      if (first) first.focus();
    }
    function close() {
      menu.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    openBtn.addEventListener('click', open);
    $$('[data-fff-menu-close]', menu).forEach(function (el) { el.addEventListener('click', close); });
    menu.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = $$('a, button', menu).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
  }

  /* ---------- Catalogue : filtres et tri ---------- */
  function initCollection(root) {
    var grid = $('[data-fff-grid]', root);
    if (!grid || grid.dataset.fffBound) return;
    grid.dataset.fffBound = '1';
    var cards = $$('[data-fff-card]', grid);
    cards.forEach(function (c, i) { c.dataset.index = i; });
    var tile = $('[data-fff-tile]', grid);
    var tileAfter = tile ? cards.indexOf(tile.previousElementSibling) : -1;
    var chips = $$('[data-fff-chip]', root);
    var sortSel = $('[data-fff-sort]', root);
    var countEl = $('[data-fff-count]', root);
    var emptyEl = $('[data-fff-empty]', root);
    var state = { type: 'all', sort: 'default' };

    // Compteurs par type
    chips.forEach(function (chip) {
      var t = chip.getAttribute('data-fff-chip');
      var n = t === 'all' ? cards.length : cards.filter(function (c) { return c.dataset.type === t; }).length;
      var el = $('[data-fff-chip-count]', chip);
      if (el) el.textContent = n;
      if (t !== 'all' && n === 0) chip.hidden = true;
    });

    function apply() {
      var visible = cards.filter(function (c) { return state.type === 'all' || c.dataset.type === state.type; });
      cards.forEach(function (c) { c.hidden = visible.indexOf(c) === -1; });
      var ordered = cards.slice();
      if (state.sort === 'asc') ordered.sort(function (a, b) { return a.dataset.price - b.dataset.price; });
      else if (state.sort === 'desc') ordered.sort(function (a, b) { return b.dataset.price - a.dataset.price; });
      else ordered.sort(function (a, b) { return a.dataset.index - b.dataset.index; });
      ordered.forEach(function (c) { grid.appendChild(c); });
      if (tile) {
        var showTile = state.type === 'all' && state.sort === 'default' && tileAfter > -1;
        tile.hidden = !showTile;
        if (showTile) cards[tileAfter].after(tile);
      }
      if (countEl) countEl.textContent = visible.length;
      if (emptyEl) emptyEl.hidden = visible.length !== 0;
      chips.forEach(function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-fff-chip') === state.type ? 'true' : 'false');
      });
    }

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        state.type = chip.getAttribute('data-fff-chip');
        apply();
        try {
          var url = new URL(window.location.href);
          if (state.type === 'all') url.searchParams.delete('type'); else url.searchParams.set('type', state.type);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      });
    });
    if (sortSel) sortSel.addEventListener('change', function () { state.sort = sortSel.value; apply(); });

    try {
      var t = new URL(window.location.href).searchParams.get('type');
      if (t && chips.some(function (c) { return c.getAttribute('data-fff-chip') === t && !c.hidden; })) state.type = t;
    } catch (e) {}
    apply();
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-fff-product-json]', root);
    if (!jsonEl || root.dataset.fffBound) return;
    root.dataset.fffBound = '1';
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var inv = data.inventory || {};
    var low = data.low || 3;
    if (data.moneyFormat) window.FFF_MONEY_FORMAT = data.moneyFormat;

    var form = $('[data-fff-form]', root);
    var idInput = $('[data-fff-variant-input]', root);
    var addBtn = $('[data-fff-add-btn]', root);
    var errorEl = $('[data-fff-error]', root);
    var priceEl = $('[data-fff-price]', root);
    var compareEl = $('[data-fff-compare]', root);
    var stockEl = $('[data-fff-stock]', root);
    var sticky = $('[data-fff-sticky]', root);
    var stickyMeta = $('[data-fff-sticky-meta]', root);
    var stickyBtn = $('[data-fff-sticky-btn]', root);
    var optButtons = $$('[data-fff-opt]', root);

    /* Galerie */
    var track = $('[data-fff-track]', root);
    var slides = track ? $$('.fff-gal__slide', track) : [];
    var thumbs = $$('[data-fff-thumb]', root);
    var counter = $('[data-fff-counter]', root);
    var current = 0;

    function setActive(i) {
      current = i;
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    function goTo(i, instant) {
      if (!track || !slides.length) return;
      i = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: instant ? 'auto' : 'smooth' });
      setActive(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-fff-thumb'), 10)); });
    });
    var prev = $('[data-fff-prev]', root), next = $('[data-fff-next]', root);
    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i !== current && i >= 0 && i < slides.length) setActive(i);
        });
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      });
    }

    /* Variantes */
    var selected = [];
    var startId = idInput ? parseInt(idInput.value, 10) : null;
    var startVariant = variants.filter(function (v) { return v.id === startId; })[0] || variants[0];
    if (startVariant) selected = startVariant.options.slice();

    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }
    function stockOf(v) {
      var s = v && inv[v.id];
      return s || { q: 0, t: false };
    }

    function updateOptionStates() {
      optButtons.forEach(function (btn) {
        var pos = parseInt(btn.getAttribute('data-fff-opt'), 10) - 1;
        var val = btn.getAttribute('data-value');
        var test = selected.slice();
        test[pos] = val;
        var v = findVariant(test);
        var isOut = !v || !v.available;
        var s = stockOf(v);
        var isLow = !!v && v.available && s.t && s.q > 0 && s.q <= low;
        btn.classList.toggle('is-out', isOut);
        btn.classList.toggle('is-low', isLow);
        btn.setAttribute('aria-pressed', selected[pos] === val ? 'true' : 'false');
        var label = val + (isOut ? ', épuisé' : isLow ? ', dernières pièces' : '');
        btn.setAttribute('aria-label', label);
      });
      $$('[data-fff-optval]', root).forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-fff-optval'), 10) - 1;
        el.textContent = selected[pos] || '';
      });
    }

    function stockMessage(v) {
      if (!stockEl) return;
      var label = data.single ? '' : ' en ' + v.title.replace(/ \/ /g, ', ');
      var s = stockOf(v);
      var dot, text;
      if (!v.available) { dot = 'red'; text = 'Épuisé' + label + '.'; }
      else if (s.t && s.q > 0 && s.q <= low) { dot = 'red'; text = 'Dernières pièces' + label + '.'; }
      else if (s.t) { dot = 'green'; text = 'En stock' + label + '.'; }
      else { dot = 'green'; text = 'Disponible' + label + '.'; }
      stockEl.innerHTML = '<span class="fff-dot fff-dot--' + dot + '"></span><span></span>';
      stockEl.lastChild.textContent = text;
    }

    function render(v, fromUser) {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Indisponible'; }
        if (stockEl) stockEl.textContent = "Cette combinaison n'existe pas.";
        updateOptionStates();
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      if (compareEl) {
        var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
        compareEl.hidden = !hasCompare;
        compareEl.textContent = hasCompare ? formatMoney(v.compare_at_price) : '';
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      }
      if (stickyMeta) stickyMeta.textContent = (data.single ? '' : v.title + ', ') + formatMoney(v.price);
      if (stickyBtn) stickyBtn.disabled = !v.available;
      stockMessage(v);
      updateOptionStates();
      if (fromUser) {
        if (v.featured_media && v.featured_media.id) {
          var idx = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.featured_media.id));
          if (idx > -1) goTo(idx);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }

    optButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-fff-opt'), 10) - 1;
        selected[pos] = btn.getAttribute('data-value');
        var v = findVariant(selected);
        // Si la combinaison n'existe pas, on prend la première variante disponible avec cette valeur
        if (!v) {
          v = variants.filter(function (x) { return x.options[pos] === selected[pos] && x.available; })[0] ||
              variants.filter(function (x) { return x.options[pos] === selected[pos]; })[0];
          if (v) selected = v.options.slice();
        }
        render(v, true);
      });
    });

    if (startVariant) {
      render(startVariant, false);
      if (startVariant.featured_media && window.location.search.indexOf('variant=') > -1) {
        var idx0 = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(startVariant.featured_media.id));
        if (idx0 > 0) setTimeout(function () { goTo(idx0, true); }, 50);
      }
    }

    /* Guide des tailles */
    $$('[data-fff-open-guide]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var d = $('[data-fff-guide]', root);
        if (!d) return;
        d.open = true;
        d.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var sum = $('summary', d);
        if (sum) sum.focus({ preventScroll: true });
      });
    });

    /* Ajout au panier */
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        var label = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Ajout…'; }
        addToCart(new FormData(form)).then(function () {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Ajouté au panier'; }
          setTimeout(function () { if (addBtn) addBtn.textContent = label; }, 1800);
          openCart();
        }).catch(function (err) {
          if (addBtn) { addBtn.disabled = false; addBtn.textContent = label; }
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
        });
      });
    }

    /* Barre collante mobile */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
      });
    }
  }

  /* ---------- Démarrage ---------- */
  function init(root) {
    root = root || document;
    $$('[data-fff-header]', root).forEach(initMenu);
    if (root.matches && root.matches('[data-fff-header]')) initMenu(root);
    $$('[data-fff-collection]', root).forEach(initCollection);
    $$('[data-fff-product]', root).forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); watchCartCount(); });
  } else {
    init(document); watchCartCount();
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();